module.exports = __webpack_public_path__ + "static/media/NINE.a2cbf37d.png";